<section id="faq" class="section faq-section">
  <div class="container">
    <div class="section-heading compact-heading">
      <h2>{{'landing.faq.title'|traduccion}}</h2>
      <p>{{'landing.faq.subtitle'|traduccion}}</p>
    </div>

    <div class="faq-grid">
      @for (faq of faqs; track faq.id) {
        <details class="faq-item">
          <summary>{{ faq.question }} <span>⌄</span></summary>
          <p>{{ faq.answer }}</p>
        </details>
      }
    </div>

    <div class="faq-cta">
      <a class="button button-primary" href="#reservar">{{'landing.bookNow'|traduccion}} <span>→</span></a>
    </div>
  </div>
</section>
